import { useState, useEffect } from "react";

const SERVERS = {
  dev:    { label:"sit-script-device",         path:"/dev-api",    accent:"#06b6d4", tag:"DEV",     tab:"dev", grp:"tnpdcl" },
  prod:   { label:"tnpdcl-python-one",      path:"/prod-api",   accent:"#f97316", tag:"PS-1",    tab:"prod", grp:"tnpdcl" },
  device: { label:"tnpdcl-kfk-mqtt-red", path:"/device-api", accent:"#8b5cf6", tag:"PS-2",    tab:"device", grp:"tnpdcl" },
  micro:  { label:"tnpdcl-docker-one",       path:"/micro-api",  accent:"#10b981", tag:"MICRO",   tab:"micro", grp:"tnpdcl" },
  ps3:    { label:"tnpdcl-python-two",    path:"/ps3-api",    accent:"#e11d48", tag:"PS-3",    tab:"ps3", grp:"tnpdcl" },
  ep:     { label:"tnpdcl-con-solar-emp", path:"/ep-api",     accent:"#f59e0b", tag:"EP",      tab:"ep", grp:"tnpdcl" },
  fsarabbitmq: { label:"BL-PROD-RabbitMQ", path:"/fsa-rabbitmq-api", accent:"#f97316", tag:"FSA-MQ", tab:"fsarabbitmq", grp:"fsa" },
  fsascript: { label:"BL-PROD-FSA-Script", path:"/fsa-script-api", accent:"#f59e0b", tag:"FSA-SCRIPT", tab:"fsascript", grp:"fsa" },
  fsadocker1: { label:"BL-PROD-FSA-Docker-1", path:"/fsa-docker1-api", accent:"#06b6d4", tag:"FSA-DOCK1", tab:"fsadocker1", grp:"fsa" },
  fsaevents: { label:"BL-PROD-FSA-Events", path:"/fsa-events-api", accent:"#8b5cf6", tag:"FSA-EVENTS", tab:"fsaevents", grp:"fsa" },
  fsakafkazk: { label:"BL-PROD-Kafka-ZK", path:"/fsa-kafkazk-api", accent:"#22c55e", tag:"FSA-KZK", tab:"fsakafkazk", grp:"fsa" },
  fsaconfig: { label:"BL-PROD-Config", path:"/fsa-config-api", accent:"#eab308", tag:"FSA-CFG", tab:"fsaconfig", grp:"fsa" },
  fsagps: { label:"BL-GPS-Prod", path:"/fsa-gps-api", accent:"#ec4899", tag:"FSA-GPS", tab:"fsagps", grp:"fsa" },
  reproc:   { label:"tnpdcl-events-agg",  path:"/reproc-api",   accent:"#a78bfa", tag:"REPROC",   tab:"reproc", grp:"tnpdcl" },
  dataproc:  { label:"tnpdcl-dataproc-bn360",   path:"/dataproc-api",  accent:"#06b6d4", tag:"DATAPROC", tab:"dataproc", grp:"tnpdcl" },
  devdocker: { label:"sit-docker",             path:"/devdocker-api", accent:"#10b981", tag:"SIT-DOCK", tab:"devdocker", grp:"tnpdcl" },
  db:     { label:"DB Primary",     path:"/db-api",     accent:"#10b981", tag:"DB-PRI",  tab:"db", grp:"tnpdcl" },
  fsadb:    { label:"FSA-DB-Primary",   path:"/fsadb-api",  accent:"#14b8a6", tag:"FSADB-PRI", tab:"fsadb", grp:"fsa" },
  fsadbsec: { label:"FSA-DB-Secondary", path:"/fsadb2-api", accent:"#14b8a6", tag:"FSADB-SEC", tab:"fsadb", grp:"fsa" },
  fsadbter: { label:"FSA-DB-Tertiary",  path:"/fsadb3-api", accent:"#14b8a6", tag:"FSADB-TER", tab:"fsadb", grp:"fsa" },
  dbsec1: { label:"DB Secondary-1", path:"/db2-api",    accent:"#10b981", tag:"DB-SEC1", tab:"db", grp:"tnpdcl" },
  dbsec2: { label:"DB Secondary-2", path:"/db3-api",    accent:"#10b981", tag:"DB-SEC2", tab:"db", grp:"tnpdcl" },
};
const BASE = "";

export default function HomePanel({ token, theme, env, setTab }) {
  const [items,   setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [updated, setUpdated] = useState(null);
  const [countdown, setCountdown] = useState(30);

  const H = { "X-Auth-Token": token };

  const loadAll = async () => {
    setLoading(true);
    const alerts = [];

    // ── SERVERS ──────────────────────────────────────────
    const ACTIVE = Object.fromEntries(Object.entries(SERVERS).filter(([k,s]) => !env || !s.grp || s.grp === env));
    await Promise.all(Object.entries(ACTIVE).map(async ([key, s]) => {
      try {
        const [mr, sr] = await Promise.all([
          fetch(`${BASE}${s.path}/metrics`, { headers: H }),
          fetch(`${BASE}${s.path}/services`, { headers: H }).catch(()=>({ok:false})),
        ]);
        const m = await mr.json();
        const sv = sr.ok!==false ? await sr.json().catch(()=>({})) : {};

        const cpu  = m?.cpu?.percent  || 0;
        const ram  = m?.ram?.percent  || 0;
        const disks = m?.disks || {};
        const failed = sv?.summary?.failed || 0;

        if (cpu > 90)
          alerts.push({ sev:"critical", cat:"SERVER", label:s.label, tag:s.tag,
            metric:"CPU", value:`${cpu}%`, detail:`CPU usage critical`, tab:key, accent:s.accent });

        if (ram > 90)
          alerts.push({ sev:"critical", cat:"SERVER", label:s.label, tag:s.tag,
            metric:"RAM", value:`${ram}%`, detail:`Memory usage critical`, tab:key, accent:s.accent });

        Object.entries(disks).forEach(([mount, d]) => {
          if (d.percent > 80)
            alerts.push({ sev:"critical", cat:"SERVER", label:s.label, tag:s.tag,
              metric:"DISK", value:`${d.percent}%`, detail:`${mount} at ${d.percent}% — needs attention`, tab:key, accent:s.accent });
        });

        if (failed > 0)
          alerts.push({ sev:"critical", cat:"SERVICE", label:s.label, tag:s.tag,
            metric:"FAILED", value:`${failed} svc`, detail:`${failed} service(s) failed`, tab:key, accent:"#ef4444" });

        // Check individual service CPU/RAM
        (sv?.services || []).forEach(svc => {
          const scpu = parseFloat((svc.cpu||"0").toString().replace("%",""));
          const smem = parseFloat((svc.mem_pct||"0").toString().replace("%",""));
          if (scpu > 80)
            alerts.push({ sev:"critical", cat:"SERVICE", label:s.label, tag:s.tag,
              metric:"HIGH CPU", value:`${scpu}%`, detail:`${svc.name}: CPU ${scpu}%`, tab:key, accent:s.accent });
          if (smem > 90)
            alerts.push({ sev:"critical", cat:"SERVICE", label:s.label, tag:s.tag,
              metric:"HIGH MEM", value:`${smem}%`, detail:`${svc.name}: Memory ${smem}% of limit`, tab:key, accent:s.accent });
        });

      } catch(e) {
        alerts.push({ sev:"critical", cat:"SERVER", label:s.label, tag:s.tag,
          metric:"OFFLINE", value:"DOWN", detail:`Server unreachable`, tab:key, accent:"#ef4444" });
      }
    }));

    // ── KAFKA (TNPDCL only) ───────────────────────────────
    if (env !== "fsa") await Promise.all([
      fetch(`${BASE}/kafka-dev-api/kafka`, { headers: H }).then(r=>r.json()).then(d => {
        if (d?.broker?.status !== "running")
          alerts.push({ sev:"critical", cat:"KAFKA", label:"tnpdcl-kfk-mqtt-red", tag:"DEV",
            metric:"BROKER", value:"DOWN", detail:"Kafka broker offline", tab:"kafka", accent:"#f59e0b" });
      }).catch(()=>{}),
      fetch(`${BASE}/kafka-ps2-api/kafka`, { headers: H }).then(r=>r.json()).then(d => {
        if (d?.broker?.status !== "running")
          alerts.push({ sev:"critical", cat:"KAFKA", label:"TN-PS-MQTT", tag:"PS-2",
            metric:"BROKER", value:"DOWN", detail:"Kafka broker offline", tab:"kafka", accent:"#f59e0b" });
      }).catch(()=>{}),
    ]);

    // ── REDIS ─────────────────────────────────────────────
    await Promise.all([
      fetch(`${BASE}/redis-dev-api/redis`, { headers: H }).then(r=>r.json()).then(d => {
        const r = d?.[0];
        if (!r) return;
        const maxMem = r.memory?.max;
        if (maxMem && maxMem !== "No limit") {
          const used = parseFloat(r.memory?.used);
          const max  = parseFloat(maxMem);
          if (used/max > 0.8)
            alerts.push({ sev:"critical", cat:"REDIS", label:"tnpdcl-kfk-mqtt-red", tag:"DEV",
              metric:"MEMORY", value:r.memory?.used, detail:`Redis memory ${r.memory?.used} / ${maxMem}`, tab:"redis", accent:"#ef4444" });
        }
        if (r.stats?.evicted_keys > 100)
          alerts.push({ sev:"critical", cat:"REDIS", label:"tnpdcl-kfk-mqtt-red", tag:"DEV",
            metric:"EVICTED", value:r.stats.evicted_keys, detail:`${r.stats.evicted_keys} keys evicted`, tab:"redis", accent:"#ef4444" });
      }).catch(()=>{}),
      fetch(`${BASE}/redis-ps2-api/redis`, { headers: H }).then(r=>r.json()).then(d => {
        const r = d?.[0];
        if (!r) return;
        if (r.stats?.evicted_keys > 100)
          alerts.push({ sev:"critical", cat:"REDIS", label:"TN-PS-MQTT", tag:"PS-2",
            metric:"EVICTED", value:r.stats.evicted_keys, detail:`${r.stats.evicted_keys} keys evicted`, tab:"redis", accent:"#ef4444" });
      }).catch(()=>{}),
    ]);

    // ── MQTT ──────────────────────────────────────────────
    fetch(`${BASE}/mqtt-ps2-api/mqtt`, { headers: H }).then(r=>r.json()).then(brokers => {
      (brokers||[]).forEach(b => {
        if (b.status !== "online")
          alerts.push({ sev:"critical", cat:"MQTT", label:`MQTT :${b.port}`, tag:b.label,
            metric:"OFFLINE", value:"DOWN", detail:`${b.label} broker offline`, tab:"mqtt", accent:"#8b5cf6" });
      });
    }).catch(()=>{});

    // ── DOCKER ────────────────────────────────────────────
    try {
      const [dr, er] = await Promise.all([
        fetch(`${BASE}/micro-api/services`, { headers: H }).then(r=>r.json()),
        fetch(`${BASE}/micro-api/docker/errors`, { headers: H }).then(r=>r.json()),
      ]);
      (dr?.services||[]).forEach(c => {
        if (c.status==="failed")
          alerts.push({ sev:"critical", cat:"DOCKER", label:"tnpdcl-docker-one", tag:c.name,
            metric:"CRASHED", value:"EXITED", detail:`Container ${c.name} crashed`, tab:"docker", accent:"#ef4444" });
        const mem = parseFloat((c.mem_pct||"0").toString().replace("%",""));
        const cpu = parseFloat((c.cpu||"0").toString().replace("%",""));
        if (mem > 80)
          alerts.push({ sev:"critical", cat:"DOCKER", label:"tnpdcl-docker-one", tag:c.name,
            metric:"HIGH MEM", value:`${mem}%`, detail:`${c.name}: Memory ${mem}% of limit (${c.memory})`, tab:"docker", accent:"#ef4444" });
        if (cpu > 50)
          alerts.push({ sev:"critical", cat:"DOCKER", label:"tnpdcl-docker-one", tag:c.name,
            metric:"HIGH CPU", value:`${cpu}%`, detail:`${c.name}: CPU usage ${cpu}%`, tab:"docker", accent:"#f59e0b" });
        if (c.log_mb != null && c.log_mb >= 2048) {
          const lgb = (c.log_mb/1024).toFixed(1);
          const img = (c.description||"").split(":")[0];
          alerts.push({ sev:"warning", cat:"DOCKER LOG", label:"tnpdcl-docker-one", tag:c.name,
            metric:"LOG SIZE", value:`${lgb} GB`, detail:`${c.name} (${img}): log ${lgb} GB — needs cleanup`, tab:"docker", accent:"#f59e0b" });
        }
      });
      (er?.errors||[]).forEach(e => {
        const tsMatch = e.line.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}):\d{2}/);
        const ts = tsMatch ? tsMatch[1]+" "+tsMatch[2]+" UTC" : "";
        const msg = e.line.replace(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+Z\s*/,"").trim();
        const typeLabel = e.type==="OOM" ? "OOM ERROR" : (e.type==="TIMEOUT" ? "TIMEOUT" : "ERROR");
        alerts.push({ sev:"critical", cat:"DOCKER", label:"tnpdcl-docker-one", tag:e.container,
          metric:typeLabel, value:ts, detail:msg.length>100?msg.substring(0,100)+"...":msg,
          tab:"docker", accent:"#ef4444" });
      });
    } catch(e) {}

    setItems(alerts);
    setLoading(false);
    setUpdated(new Date().toLocaleTimeString());
  };

  useEffect(() => {
    loadAll();
    const id = setInterval(loadAll, 30000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    setCountdown(30);
    const id = setInterval(() => {
      setCountdown(c => {
        if (c <= 1) { return 30; }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [updated]);

  const catColor = { SERVER:"#06b6d4", SERVICE:"#f97316", KAFKA:"#f59e0b", REDIS:"#ef4444", MQTT:"#8b5cf6", DOCKER:"#10b981", "DOCKER LOG":"#f59e0b", CPU:"#06b6d4", MEMORY:"#8b5cf6", DISK:"#f97316", "DOWN / CRASHED":"#ef4444", ERRORS:"#ef4444" };

  const [fireIdx, setFireIdx] = useState(null);
  return (
    <div style={{flex:1,overflowY:"auto",background:theme.bg,padding:24,
      fontFamily:"'Inter',sans-serif",paddingBottom:40,minHeight:0}}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:.5}}
        @keyframes flameFlicker{0%,100%{transform:translateX(-50%) scaleY(1) scaleX(1);opacity:.92}25%{transform:translateX(-50%) scaleY(1.15) scaleX(.95) translateY(-2px);opacity:1}50%{transform:translateX(-50%) scaleY(.92) scaleX(1.05) translateY(1px);opacity:.85}75%{transform:translateX(-50%) scaleY(1.08) scaleX(.98);opacity:.95}}
        @keyframes flameHue{0%,100%{filter:hue-rotate(0deg) brightness(1)}50%{filter:hue-rotate(-12deg) brightness(1.2)}}
        .bn-fire{position:absolute;right:20px;top:50%;transform:translateY(-50%);width:30px;height:40px;pointer-events:none;z-index:5}
        .bn-fire .flame{position:absolute;bottom:0;left:50%;width:24px;height:34px;background:radial-gradient(ellipse at 50% 100%,#fff6a0 0%,#ffd24d 25%,#ff8c1a 50%,#ff3d00 75%,#d81a00 100%);clip-path:polygon(50% 0%,68% 30%,80% 55%,72% 80%,88% 72%,78% 95%,50% 100%,22% 95%,12% 72%,28% 80%,20% 55%,32% 30%);animation:flameFlicker .6s ease-in-out infinite,flameHue 1.2s ease-in-out infinite;transform-origin:center bottom;box-shadow:0 0 14px 3px rgba(255,90,0,.5)}
        .bn-fire .flame-inner{position:absolute;bottom:2px;left:50%;transform:translateX(-50%);width:11px;height:19px;background:radial-gradient(ellipse at 50% 100%,#fff 0%,#fff2a0 40%,#ffd24d 100%);clip-path:polygon(50% 0%,70% 40%,65% 75%,50% 100%,35% 75%,30% 40%);animation:flameFlicker .45s ease-in-out infinite reverse;transform-origin:center bottom}`}</style>

      {/* Header */}
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:24}}>
        <div>
          <div style={{fontSize:22,fontWeight:800,color:theme.text,letterSpacing:"-.02em"}}>
            🏠 Command Center
          </div>
          <div style={{fontSize:12,color:theme.textMuted,marginTop:3}}>
            {updated?`Updated: ${updated}`:"Loading..."} · Auto-refresh 30s · All servers monitored
          </div>
        </div>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <div style={{display:"flex",alignItems:"center",gap:6,
            background:theme.inputBg,border:`1px solid ${theme.border}`,
            borderRadius:20,padding:"4px 12px"}}>
            <div style={{width:8,height:8,borderRadius:"50%",
              background:loading?"#f59e0b":"#10b981",
              animation:loading?"pulse 1s ease infinite":"none"}}/>
            <span style={{fontSize:11,color:theme.textMuted,fontFamily:"'JetBrains Mono',monospace"}}>
              {loading ? "refreshing..." : `next in ${countdown}s`}
            </span>
          </div>
          {!loading && items.length>0 && (
            <div style={{background:"rgba(239,68,68,0.12)",border:"1px solid rgba(239,68,68,0.4)",
              borderRadius:20,padding:"5px 16px",fontSize:13,fontWeight:700,color:"#ef4444",
              animation:"pulse 2s ease infinite"}}>
              🔴 {items.length} Critical Issue{items.length>1?"s":""}
            </div>
          )}
          {!loading && items.length===0 && (
            <div style={{background:"rgba(16,185,129,0.12)",border:"1px solid rgba(16,185,129,0.3)",
              borderRadius:20,padding:"5px 16px",fontSize:13,fontWeight:700,color:"#10b981"}}>
              ✅ All Systems Operational
            </div>
          )}
          <button onClick={loadAll} style={{
            background:theme.inputBg,border:`1px solid ${theme.border}`,
            color:theme.textMuted,borderRadius:6,padding:"5px 14px",cursor:"pointer",
            fontFamily:"'Inter',sans-serif",fontSize:12,fontWeight:600,
          }}>↻ Refresh</button>
        </div>
      </div>

      {/* All OK state */}
      {!loading && items.length===0 && (
        <div style={{textAlign:"center",padding:"60px 20px",
          background:theme.bgCard,border:`1px solid ${theme.border}`,borderRadius:16}}>
          <div style={{fontSize:56,marginBottom:16}}>✅</div>
          <div style={{fontSize:20,fontWeight:800,color:"#10b981",marginBottom:8}}>
            All Systems Operational
          </div>
          <div style={{fontSize:14,color:theme.textMuted,maxWidth:400,margin:"0 auto"}}>
            No critical issues detected across all servers, services, Kafka, Redis, MQTT and Docker containers.
          </div>
        </div>
      )}

      {/* GROUPED SECTIONS - alerts by metric bucket */}
      {items.length>0 && (() => {
        const metricBucket = (it) => {
          const m = (it.metric||"").toUpperCase();
          if (m.includes("CPU")) return "CPU";
          if (m.includes("MEM") || m==="RAM") return "MEMORY";
          if (m.includes("DISK")) return "DISK";
          if (m.includes("LOG")) return "DOCKER LOG";
          if (m.includes("CRASH") || m.includes("FAIL") || m.includes("OFFLINE") || m.includes("EXITED")) return "DOWN / CRASHED";
          if (m.includes("OOM") || m.includes("ERROR")) return "ERRORS";
          return it.cat || "OTHER";
        };
        const groups = {};
        items.forEach(it => { const b=metricBucket(it); (groups[b] = groups[b] || []).push(it); });
        const catOrder = ["DOWN / CRASHED","CPU","MEMORY","DISK","DOCKER LOG","ERRORS","KAFKA","REDIS","MQTT"];
        const cats = Object.keys(groups).sort((a,b)=>{
          const ia=catOrder.indexOf(a), ib=catOrder.indexOf(b);
          return (ia<0?99:ia)-(ib<0?99:ib);
        });
        return (
        <div style={{display:"flex",flexDirection:"column",gap:20}}>
          {cats.map(cat => (
            <div key={cat}>
              <div style={{fontSize:13,fontWeight:800,letterSpacing:".08em",
                color:catColor[cat]||"#ef4444",marginBottom:8,textTransform:"uppercase",
                display:"flex",alignItems:"center",gap:8}}>
                {cat}
                <span style={{fontSize:11,fontWeight:600,color:theme.textMuted,
                  background:`${catColor[cat]||"#ef4444"}18`,padding:"1px 8px",borderRadius:10}}>
                  {groups[cat].length}
                </span>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
          {groups[cat].map((item,i)=>(
            <div key={i} onClick={()=>setTab(item.tab)}
              style={{
                background:"rgba(239,68,68,0.06)",
                border:"1px solid rgba(239,68,68,0.25)",
                borderLeft:`4px solid ${item.accent||"#ef4444"}`,
                borderRadius:10,padding:"14px 18px",cursor:"pointer",
                display:"grid",gridTemplateColumns:"100px 140px 140px 1fr 120px",
                alignItems:"center",gap:12,transition:"background .15s",
                position:"relative",
                boxShadow: parseFloat(item.value)>85 ? "0 0 22px 3px rgba(239,68,68,0.6)" : "none",
              }}
              onMouseEnter={e=>{e.currentTarget.style.background="rgba(239,68,68,0.1)";setFireIdx(i);}}
              onMouseLeaveCapture={()=>setFireIdx(null)}
              onMouseLeave={e=>e.currentTarget.style.background="rgba(239,68,68,0.06)"}>
              {parseFloat(item.value)>85 && (
                <div className="bn-fire"><div className="flame"></div><div className="flame-inner"></div></div>
              )}

              {/* Category */}
              <div style={{display:"flex",flexDirection:"column",gap:3}}>
                <span style={{fontSize:10,fontWeight:700,letterSpacing:".1em",
                  color:catColor[item.cat]||"#ef4444"}}>{item.cat}</span>
                <span style={{fontSize:12,fontWeight:700,color:"#ef4444"}}>{item.metric}</span>
              </div>

              {/* Server */}
              <div style={{display:"flex",flexDirection:"column",gap:2}}>
                <span style={{fontSize:12,fontWeight:600,color:theme.text}}>{item.label}</span>
                <span style={{fontSize:10,color:item.accent||theme.textMuted,
                  background:`${item.accent||"#64748b"}15`,padding:"1px 6px",
                  borderRadius:4,fontWeight:700,display:"inline-block",width:"fit-content"}}>{item.tag}</span>
              </div>

              {/* Value */}
              <div style={{fontSize:18,fontWeight:800,color:"#ef4444",
                fontFamily:"'JetBrains Mono',monospace"}}>{item.value}</div>

              {/* Detail */}
              <div style={{fontSize:12,color:theme.text,
                overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{item.detail}</div>

              {/* Arrow */}
              <div style={{textAlign:"right",fontSize:12,color:theme.textMuted}}>
                Click to view →
              </div>
            </div>
          ))}
              </div>
            </div>
          ))}
        </div>
        );
      })()}
    </div>
  );
}
